import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { apiHelper } from "../lib/ApiHelper";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
ModuleRegistry.registerModules([
    ClientSideRowModelModule
]);
import DatePicker from 'react-datepicker';
import { LicenseManager } from "@ag-grid-enterprise/core";
import PRHLoader from "../lib/PRHLoader";
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

export default function BulkPopUp(props) {
    const [selectedISBN, setSelectedISBN] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [titleList, setTitleList] = useState([]);
    const [titleSelected, setTitleSelected] = useState(null);
    const [AgendaDate, setAgendaDate] = useState(null);
    const [ExpirationDate, setExpirationDate] = useState(null);
    const [updatingTitleStatus, setUpdatingTitleStatus] = useState(false);
    const [loadingStatus, setloadingStatus] = useState(false);
    const gridApi = useRef(null);
    const [maxDate, setMaxDate] = useState('');
    const selectTitle = async (e) => {
        setTitleSelected(e.target.value);
    }
    const [gridOptions, setGridOptions] = useState({
        defaultColDef: {
            resizable: true,
            sortable: true,
        },
        animateRows: true,
        accentedSort: true,
        suppressRowClickSelection: true,
        onSelectionChanged: onSelectionChanged,
        rowSelection: 'multiple',
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
    },
    )

    const columnDefs = [
        { headerName: '', pinned: "left", width: 40, minWidth: 10, checkboxSelection: true, headerCheckboxSelection: true, suppressSizeToFit: true, filter: false, headerClass: "HeaderClassSource1", cellClass: "checkboxcell" },
        { headerName: "ISBN", field: "isbn", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 100 },
        { headerName: "Title", field: "title", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 150 },
        {
            headerName: "Author", field: "author", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 150
        },

        { headerName: "Status", field: "status", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70 },

        {
            headerName: "SubStatus", field: "subStatus", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70
        },
        {
            headerName: "Agenda Date", field: "agendaDate", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource  right-align", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 80, cellClass: "cell-text-right"
        },
        {
            headerName: "OSD", field: "osd", headerClass: "HeaderClassSource header-text-right", cellClass: "CellClassSource", cellRenderer: (params) => {
                if ((params.value == '0001-01-01T00:00:00')) { return <span></span>; }
                return <span>{showFormatDate(params.value)}</span>;

            }, width: 80,cellClass: "cell-text-right"
        },
        {
            headerName: "SS", field: "ss", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 50
        },
        {
            headerName: "FMT", field: "fmt", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 50
        },

    ];

    const updateClick = () => {

        if (titleSelected) {
            updateISBN();
        }
    }
    const validateDate = (dateString) => {
        if (!dateString)
            return false;
        var date = new Date(dateString);
        if (isNaN(date.getTime())) return false;
        else { return true; }

    }
    const expirationDateSelect = async (value) => {
        if (value == null) {
            setExpirationDate(null);
        }
        if (!validateDate(value)) {
            return;
        }
        const dateToSave = new Date(value);

       
/*        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;*/
        // const data = new Date(formattedDate);
        const data = new Date(dateToSave.setHours(0, 0, 0, 0));
        setExpirationDate(data);
    }
    const agendaDateSelect = async (value) => {
        if (value == null) {
            setAgendaDate(null);
        }
        if (!validateDate(value)) {
            return;
        }
 
        const date = new Date(value);
     /*   const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;*/
       //const data = new Date(formattedDate);
       //const dateToSave = new Date(value);
        const data = new Date(date.setHours(0, 0, 0, 0));
        setAgendaDate(data);
    
    }

    const updateISBN = async () => {

        try {
            const LocaldataPayLoad = LocalPayLoad();
            const payload = await createPayload();
            const res = await apiHelper.inventoryPostCall("manageISBNStatus", payload);
            if (res)
                props.onClose(LocaldataPayLoad);
        } catch (e) {
            console.error("bulk update failed", e);
        }
    }
    const getDateValue = (value) => {
        const date = new Date(value);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
     return `${year}-${month}-${day}`;
    }

    const createPayload = async () => {  

        const payload = {
            isbnList: selectedISBN,
            statusId: titleSelected,
            upn: props.upn,
            ExpirationDate: (titleSelected == 23) ? getDateValue(ExpirationDate) : null,
            AgendaDate: (titleSelected == 16) ? getDateValue(AgendaDate) : null
        }
        return payload;
    }

    const LocalPayLoad =  () => {

        const payload = {
            isbnList: selectedISBN,
            statusId: titleSelected,
            upn: props.upn,
            ExpirationDate: (titleSelected == 23) ? ExpirationDate : null,
            AgendaDate: (titleSelected == 16) ? AgendaDate : null
        }
        return payload;
    }
    function onSelectionChanged() {
        const selectedRows = gridApi?.current?.getSelectedRows();
        if (selectedRows != null) {
            const isbnList = selectedRows.map(i => i.isbn);
            setSelectedISBN(isbnList);
        }
    }
    const setCurrDate = () => {

        const currentDate = new Date();

        // Add 90 days to the current date
        const maxDate = new Date();
        maxDate.setDate(currentDate.getDate() + 90);

        // Format the date to a readable format (optional)
        const formattedMaxDate = maxDate.toISOString().split('T')[0];
        setMaxDate(formattedMaxDate);
    }
    const fetchTitleList = async () => {
        try {
            setloadingStatus(true);
            let data = await apiHelper.getStatus();
            if (data && data.length > 0) {
                data = await data.sort((a, b) => {
                    if (a.status < b.status) return -1;
                    if (a.status > b.status) return 1;
                });
                setTitleList(data.filter(item => item.manualStatus.toLowerCase() == 'y'));
            }
            if (props.bulkDKstatus) {
                setTitleSelected(5);
            }
        } catch (error) { console.log(error); } finally {
            setloadingStatus(false);
        }
    }

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    }
    const onGridReady = async (params) => {
        gridApi.current = params.api;
        await fetchRowData();      
    };
  
    const fetchRowData = async () => {
        try {
            const isbns = props.ISBNList.map(i => i.isbn);
            const data = await apiHelper.inventoryPostCall("getBulkStatus", isbns);
            if (data) {
                const filteredData = data.filter(i => i.audience === props.audience);
                setRowData(filteredData);
            }
        } catch (e) {
            console.error("get bulk status failed", e);
        }
    }
    useEffect(() => {
        if (rowData.length > 0 && gridApi)
        gridApi.current.selectAll();
    },[rowData])

    useEffect(() => {
        fetchTitleList();
        setCurrDate();
    }, []);
    return (
        <>
            <div className="popup-overlay container-fluid mt-4">
                <div className="blk-popup"><button className="popup-close-btn" onClick={()=>props?.onClose(null)}></button>
                    <div className="blk-popup-content"  >
                        <Row className="popup-header left-align">{props.bulkDKstatus ? 'Update Agenda Section':'Update Status'}</Row>
                        <Row>
                            <Col className="flex-grow-1 mt-1">
                                <table className="input-table">
                                    <tr>
                                        <th className="pl-1">{props.bulkDKstatus ? 'Agenda Section' : 'Title Status'}</th>
                                    </tr>
                                    <tr>
                                        <td className="pl-1">
                                            <select className="custom-input ml-0 ttl-select" name="TitleList" onChange={selectTitle} value={titleSelected || ''} disabled={props.bulkDKstatus}>
                                                <option value="" disabled>Select...</option>
                                                {titleList.map((item) => { return (<option key={item.statusId} value={item.statusId}>{item.status}{item.subStatus && item.subStatus != "" ? ("-" + item.subStatus) : ""}</option>) })}
                                            </select>
                                        </td>
                                    </tr>
                                </table>
                            </Col>
                            <Col className="flex-grow-1 mt-1">
                                <table className="input-table">
                                    <tr>
                                        <th> <div hidden={titleSelected == null || !( titleSelected == 16 || titleSelected == 23)}>
                                            {titleSelected == 23 ? (<span className="meta-title" title="blank">Expiration Date</span>)
                                                : (<span className="meta-title" title="blank">Agenda Date</span>)}
                                        </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div hidden={titleSelected == null || !(titleSelected == 16 || titleSelected == 23)}>
                                                <div>
                                         
                                            <p>
                                                {titleSelected == 23 ? (
                                                    <DatePicker
                                                                className={`'custom-input right-align left-p-input dt-picker' ${ExpirationDate == null || ExpirationDate == "" ? 'showerror':''}`}
                                                        selected={ExpirationDate ?? ''}
                                                        onChange={(date) => expirationDateSelect(date)}
                                                        placeholderText="Select a date"
                                                        dateFormat="MM/dd/yyyy"
                                                        minDate={new Date()}
                                                        maxDate={maxDate}
                                                        disabled={updatingTitleStatus}
                                                    />
                                                ) : (
                                                    <DatePicker
                                                                    className={`'custom-input right-align left-p-input dt-picker' ${AgendaDate == null || AgendaDate == "" ? 'showerror' : ''}`}
                                                        selected={AgendaDate ?? ''}
                                                        onChange={(date) => agendaDateSelect(date)}
                                                        placeholderText="Select a date"
                                                        dateFormat="MM/dd/yyyy"
                                                        minDate={new Date()}
                                                        disabled={updatingTitleStatus}
                                                    />
                                                )}
                                            </p>

                                                </div>
                                            </div>
                                          {/*  <input type="text" value={(titleSelected == 5 || titleSelected == 16) ? showFormatDate(AgendaDate) : ''} style={{ textAlign: "end", paddingRight: "6px", background: "white", width: "100px" }} disabled={!(titleSelected == 5 || titleSelected == 16)}></input><input type="date" min={minDate} max={maxDate} className="date-dummy-input grey-bck" onChange={(e) => setAgendaDate(e.target.value)} hidden={!(titleSelected == 5 || titleSelected == 16)}></input>*/}
                                        </td>
                                    </tr>
                                </table>
                            </Col>
                            <Col><br />
                                <button className="ISBNSubmit" onClick={updateClick} disabled={!(titleSelected != null && selectedISBN.length > 0) || ((["16"].includes(String(titleSelected)) && (AgendaDate == null || AgendaDate == "")) || ((String(titleSelected) === "23") && (ExpirationDate == null || ExpirationDate == ""))) }>
                                    Update
                                </button>
                            </Col>
                        </Row>
                        <div className="ag-theme-balham" style={{ width: "100%", height: "60vh"}}>
                            {loadingStatus && <PRHLoader />}
                                <AgGridReact
                                    rowData={rowData}
                                    columnDefs={columnDefs}
                                    
                                    gridOptions={gridOptions}
                                    onGridReady={onGridReady}
                                ></AgGridReact>
                            </div>
                    </div>
                </div>
            </div>
        </>
    )
}